import {
	Box,
	Button,
	Text,
	Popover,
	PopoverTrigger,
	PopoverContent,
	PopoverHeader,
	InputGroup,
	Input,
	InputRightElement,
	Portal,
	PopoverArrow,
	Stack,
	useDisclosure,
} from '@chakra-ui/react';
import React from 'react';
import { UilAngleRight } from '@iconscout/react-unicons';
import PageSelectorLines from '../../canvas/PageSelectorLines';
import PopoverEditPage from './PopoverEditPage';
import { scrollBarStyle } from '../../../utils/layoutConfig';
import SearchBar from '../../home/SearchBar';
import { useSelector } from 'react-redux';
import { selectedPage } from '../../../redux/selectedPageSlice';
import { selectedPageObject, allPages } from '../../../redux/pagesSlice';

function getPagesToRender({ pages, filteredPages }) {
	if (filteredPages && filteredPages.length) {
		return filteredPages;
	} else {
		return pages;
	}
}

const PageSelectionWM = () => {
	const [filteredPages, setFilteredPages] = React.useState([]);
	const { isOpen, onToggle, onClose } = useDisclosure();

	const [filter, setFilters] = React.useState({ textFilter: '' });
	// const [selectedPage,setSelectedPage] = React.useContext(SelectedPageContext);
	// const [selectedPageObject,setSelectedPageObject] = React.useState(pages.find(el=>el.pageId == selectedPage))
	const [editPage, setEditPage] = React.useState(false);
	const selectedPageObjectValue = useSelector(selectedPageObject);
	const selectedPageValue = useSelector(selectedPage);
	const pages = useSelector(allPages);

	React.useEffect(() => {
		setFilteredPages(pages);
	}, [pages]);

	React.useEffect(() => {
		const text = filter.textFilter;
		const newFilteredPages = pages.filter((page) => {
			return (
				page.pageName.toLowerCase().includes(text.toLowerCase()) ||
				page.pageType.toLowerCase().includes(text.toLowerCase())
			);
		});
		setFilteredPages(newFilteredPages);
	}, [filter]);

	return (
		<Popover
			isLazy={true}
			offset={[1, 19]}
			isOpen={isOpen}
			placement={'left-start'}
			arrowSize={20}
			onClose={() => {
				setEditPage(false);
				onClose();
			}}
		>
			<PopoverTrigger>
				<Button
					onClick={onToggle}
					justifyContent={'space-between'}
					width={'100%'}
					mb={2}
					px={0}
					variant={'ghost'}
					rightIcon={<UilAngleRight size={18} color="#2D3748" />}
				>
					<Box pl={5}>
						<Text textAlign={'left'}>Páginas</Text>
						<Text textTransform={'capitalize'} textAlign="left" fontWeight="normal">
							{selectedPageObjectValue && selectedPageObjectValue.pageName}
						</Text>
					</Box>
				</Button>
			</PopoverTrigger>
			<Portal>
				<PopoverContent
					zIndex={999}
					_hover={{ cursor: 'default' }}
					boxShadow="0px 0px 9px 0px #CECECE;"
					color="gray.700"
					w="500px"
					pl={5}
					pr={5}
					py={4}
				>
					<PopoverEditPage {...{ editPage, setEditPage }} />
					<PopoverHeader p={0} mb={2} fontWeight="bold" border="0" pl={1} pr={1}>
						<Text>Páginas</Text>
					</PopoverHeader>
					<PopoverArrow
						border="10px solid #CBD5E0"
						borderRight="10px solid transparent"
						borderTop={'10px solid transparent'}
					/>
					<Box pl={1} pr={1}>
						<SearchBar {...{ filter, setFilters, placeholder: 'Procure por nome da página', inputFS: 'sm' }} />
					</Box>
					<Box overflowX={'visible'} pt={6} pb={3}>
						<Stack
							sx={scrollBarStyle}
							maxHeight="425px"
							overflowY="auto"
							overflowX={'hidden'}
							spacing={2}
							pb={1}
							pl={1}
							pr={1}
						>
							<PageSelectorLines key={-1} {...{ setEditPage }} />
							{getPagesToRender({ pages, filteredPages }).map((page, index) => {
								return (
									<PageSelectorLines
										key={index}
										isSelected={selectedPageValue == page.pageId ? true : false}
										{...{ page, setEditPage, onToggle }}
									/>
								);
							})}
						</Stack>
					</Box>
				</PopoverContent>
			</Portal>
		</Popover>
	);
};
const PageSelection = React.memo(PageSelectionWM);
export default PageSelection;
